import { useTranslation } from 'react-i18next';
import UPButton from 'components/button';
import {
  MFA_CHALLENGE__BACKUP_CODES_NONE_LEFT,
  MFA_CHALLENGE__BACKUP_CODES_REMAINING,
  MFA_CHALLENGE__BACKUP_CODE_ACCEPTED_TITLE,
  MFA_CHALLENGE__CONTINUE,
} from 'translations/constants';
import { MfaCardTitle } from '../mfa-styles';
import { MfaBackupCodesExhausted, MfaBackupCodesRemaining } from './styles';

interface MfaBackupCodeAcceptedViewProps {
  /** Codes left *after* the one just spent. Never null here — `MfaChallenge` skips this step if it is. */
  remaining: number;
  onContinue: () => void;
}

/**
 * Sits between a successful backup code and the dashboard.
 *
 * An interstitial rather than a toast for two reasons. Storing the session swaps AuthRouter for
 * AppRouter and unmounts this screen, so anything rendered here would flash and vanish. And the
 * message is not incidental: this user has just proved they cannot reach their authenticator, they
 * have spent one of a finite set, and there is no endpoint — for them or for an admin — that issues
 * new ones. Re-enrolling is the only way back to a full set, and this is the moment they will act.
 */
const MfaBackupCodeAcceptedView = (props: MfaBackupCodeAcceptedViewProps) => {
  const { remaining, onContinue } = props;
  const [t] = useTranslation();

  return (
    <>
      <MfaCardTitle>{t(MFA_CHALLENGE__BACKUP_CODE_ACCEPTED_TITLE)}</MfaCardTitle>
      {remaining === 0 ? (
        <MfaBackupCodesExhausted>{t(MFA_CHALLENGE__BACKUP_CODES_NONE_LEFT)}</MfaBackupCodesExhausted>
      ) : (
        <MfaBackupCodesRemaining>
          {t(MFA_CHALLENGE__BACKUP_CODES_REMAINING, { count: remaining })}
        </MfaBackupCodesRemaining>
      )}
      <UPButton text={t(MFA_CHALLENGE__CONTINUE)} onClick={onContinue} />
    </>
  );
};

export default MfaBackupCodeAcceptedView;
